<template>
  <div class="aupplyAgain-box">
    <div class="info">
      <div class="item">
        <span>订单金额：</span>
        <span>{{ refund_data.pay_money }}</span>
      </div>
      <div class="item">
        <span>订单状态：</span>
        <span>{{ refund_data.order_status | orderStatusText }}</span>
      </div>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="补发药房" prop="hospital_name">
        <el-input
          v-model="ruleForm.hospital_name"
          size="small"
          disabled
        ></el-input>
      </el-form-item>

      <el-form-item label="补发类型" prop="again_type">
        <el-checkbox-group v-model="ruleForm.again_type">
          <el-checkbox label="中药药品" name="中药药品"></el-checkbox>
          <el-checkbox label="发票" name="发票"></el-checkbox>
          <el-checkbox label="处方笺" name="处方笺"></el-checkbox>
          <el-checkbox label="其他" name="其他"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="补发备注" prop="again_remark" class="again-remark">
        <el-input
          type="textarea"
          :rows="7"
          placeholder="请输入"
          v-model="ruleForm.again_remark"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>

      <el-form-item
        v-if="ruleForm.again_type.includes('中药药品')"
        label="补发原因"
        prop="again_reason"
      >
        <el-radio-group v-model="ruleForm.again_reason">
          <el-radio :label="1">漏发（不扣减库存）</el-radio>
          <el-radio :label="2">分批次（不扣减库存）</el-radio>
          <el-radio :label="3">破损（扣减库存及用量）</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="补发药品" prop="again_send" class="again-send">
        <el-radio-group v-model="ruleForm.again_send" @change="againSendChange">
          <el-radio :label="1">按剂补发</el-radio>
          <el-radio :label="2">按药品补发</el-radio>
        </el-radio-group>

        <div v-if="ruleForm.again_send == 1">
          <span>补发剂数：</span>
          <el-input-number
            v-model="ruleForm.total_num"
            size="small"
            :min="1"
            :max="refund_data.total_num"
            :precision="0"
            :controls="false"
            style="width: 90px"
          ></el-input-number>
          <span>&nbsp;剂</span>
          <span style="margin-left: 10px"
            >&nbsp;(处方中共{{ refund_data.total_num }}剂)</span
          >
        </div>
        <el-table
          :data="ruleForm.drug_list"
          tooltip-effect="dark"
          style="width: 100%; margin-top: 10px"
          size="medium"
          border
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column label="药品名" prop="generic_name">
            <template slot-scope="scope">
              {{ scope.row.generic_name }}
              <span v-if="scope.row.is_national_standard == 1">(新)</span>
            </template>
          </el-table-column>

          <el-table-column label="处方用量" prop="item_use_level">
            <template slot-scope="scope">
              <span>{{
                scope.row.is_national_standard == 1
                  ? scope.row.national_standard_level
                  : scope.row.item_use_level
              }}</span>
              <span>g</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="ruleForm.again_send == 2"
            label="补发数"
            width="180"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="scope.row.is_national_standard == 1"
                v-model="scope.row.item_level"
                size="small"
                :min="0.01"
                :max="
                  Number(
                    scope.row.national_standard_level * refund_data.total_num
                  )
                "
                :precision="2"
                :controls="false"
              >
              </el-input-number>
              <el-input-number
                v-else
                v-model="scope.row.item_level"
                size="small"
                :min="0.01"
                :max="Number(scope.row.item_use_level * refund_data.total_num)"
                :precision="2"
                :controls="false"
              >
              </el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="delBtn(scope.$index)" type="text"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item>
        <!-- <el-button @click="resetForm('ruleForm')">取 消</el-button> -->
        <el-button type="primary" size="medium" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import common from "../../api/common";
export default {
  props: {
    refund_data: {
      type: Object,
      require: true,
    },
  },
  data() {
    const validateAgainSend = (rule, value, callback) => {
      let isEmpty = this.ruleForm.drug_list.some((item) => {
        return !item.item_level;
      });
      if (value == 1 && !this.ruleForm.total_num) {
        callback(new Error("请输入补发剂数"));
      } else if (value == 2 && isEmpty) {
        callback(new Error("请输入补发数"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        hospital_id: "",
        hospital_name: "",
        pre_id: "",
        user_name: "",
        again_type: ["中药药品"],
        again_remark: "",
        again_reason: "",
        again_send: 1,
        total_num: undefined,
        drug_list: [],
      },
      rules: {
        hospital_name: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        again_type: [{ required: true, message: "请选择", trigger: "change" }],
        again_remark: [{ required: true, message: "请输入", trigger: "blur" }],
        again_reason: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        again_send: [{ validator: validateAgainSend, trigger: "blur" }],
      },
    };
  },
  filters: {
    orderStatusText(val) {
      switch (val) {
        case 1:
          return "待审核";
        case 2:
          return "待发药";
        case 3:
          return "待收货";
        case 4:
          return "已完成";
        case 5:
          return "不通过";
        case 6:
          return "平台退款";
      }
    },
  },
  watch: {
    refund_data: {
      handler: function (n) {
        this.ruleForm.hospital_name = n.hospital_name;
        this.ruleForm.hospital_id = n.hospital_id;
        this.ruleForm.pre_id = n.pre_id;
        this.ruleForm.user_name = n.user_name;
        if (n.item_list) {
          this.ruleForm.drug_list = JSON.parse(JSON.stringify(n.item_list));
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = _.omit(this.ruleForm, ["hospital_name"]);
          params.drug_list = params.drug_list.map((item) => {
            let obj = {
              item_id: item.item_id,
              drug_id: item.drug_id,
              generic_name: item.generic_name,
              item_use_level:
                params.again_send == 2 ? item.item_level : item.item_use_level,
            };
            return obj;
          });
          params.again_type = params.again_type.join(",");
          params.id = this.$route.query.id;
          common.saveOrderServiceSend(params).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("保存成功");
              this.$emit("comfirmAupplyAgain");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 补发药品
    againSendChange() {
      this.ruleForm.drug_list = JSON.parse(
        JSON.stringify(this.refund_data.item_list)
      );
    },
    delBtn(index) {
      if (this.ruleForm.drug_list.length == 1) {
        this.$message.warning("至少有一种药品");
        return;
      }
      this.ruleForm.drug_list.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" >
.aupplyAgain-box {
  .info {
    height: 40px;
    display: flex;
    align-items: center;
    background-color: #f2f2f2;
    margin-bottom: 10px;
    .item {
      padding: 0 20px;
    }
  }
  .demo-ruleForm {
    width: 700px;
    .again-remark {
      .el-form-item__content {
        height: 166px;
      }
    }
    .again-send {
      .el-form-item__content {
        height: auto;
      }
    }
  }
}
</style>